import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useTrackRouteChanges = (): null => {
  const location = useLocation();

  useEffect(() => {}, [location]);

  return null; // or return your component structure
};
